/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FocusEventHandler } from 'react'
import { Form, Input } from 'antd'
import classnames from 'classnames'
import { LABEL_ALIGN_TYPE } from '../form.constants'
import { formRules, Validator } from '../form.utils'
import '../form.scss'
import InfoToolTipLabel from '../infotooltip-label/infotooltip-label'

export interface InputTextAreaProps {
  showCount?: boolean
  rows?: number
  maxLength?: number
  min?: {
    value: number
    message: string
  }
  max?: {
    value: number
    message: string
  }
  isAllowClear?: boolean
  isDisabled?: boolean
  label?: string | any
  name?: string | any
  isRequired?: boolean
  labelAlign?: keyof typeof LABEL_ALIGN_TYPE
  pattern?: RegExp
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  className?: string
  inputContainerStyle?: string
  validateTrigger?: string | string[]
  validator?: Validator
  patternMessage?: string
  prefix?: React.ReactNode
  placeholder?: string
  value?: string | ReadonlyArray<string> | number | undefined
  onBlur?: FocusEventHandler<HTMLInputElement>
  isURL?: boolean
  isEmail?: boolean
  innerRef?: any
  defaultValue?: string
  htmlLabel?: string
}

const { TextArea } = Input
const InputTextArea: React.FC<InputTextAreaProps> = (
  props: InputTextAreaProps
) => {
  const {
    showCount,
    rows,
    min,
    max,
    label,
    name,
    labelAlign,
    isRequired,
    validator,
    className,
    pattern,
    patternMessage,
    isDisabled,
    isAllowClear,
    maxLength,
    validateTrigger,
    value,
    inputContainerStyle,
    isURL = false,
    isEmail = false,
    innerRef,
    defaultValue,
    htmlLabel,
  } = props

  return (
    <>
      <label htmlFor={htmlLabel ? htmlLabel : label}>
        <InfoToolTipLabel label={label} />
      </label>
      <Form.Item
        label={label}
        name={name}
        labelAlign={labelAlign}
        validateTrigger={validateTrigger}
        className={classnames('block', className)}
        rules={formRules(
          label,
          isRequired,
          validator,
          pattern,
          patternMessage,
          min,
          max,
          isURL,
          isEmail
        )}
        validateFirst={true}
        initialValue={defaultValue}
      >
        <TextArea
          showCount={showCount}
          rows={rows}
          aria-label={label}
          className={classnames(
            'form-item-input-width-textarea',
            inputContainerStyle
          )}
          disabled={isDisabled}
          id={name}
          allowClear={isAllowClear}
          maxLength={maxLength}
          value={value}
          ref={innerRef}
          defaultValue={''}
          style={{ resize: 'none' }}
        />
      </Form.Item>
    </>
  )
}

export default InputTextArea
